var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55198 8.88179C6.39798 8.88179 7.07597 9.56638 7.07597 10.4184V12.4638C7.07597 13.3098 6.39798 13.9998 5.55198 13.9998H3.52399C2.684 13.9998 2 13.3098 2 12.4638V10.4184C2 9.56638 2.684 8.88179 3.52399 8.88179H5.55198ZM12.476 8.88179C13.316 8.88179 14 9.56638 14 10.4184V12.4638C14 13.3098 13.316 13.9998 12.476 13.9998H10.448C9.60202 13.9998 8.92403 13.3098 8.92403 12.4638V10.4184C8.92403 9.56638 9.60202 8.88179 10.448 8.88179H12.476ZM5.55198 2C6.39798 2 7.07597 2.69 7.07597 3.53659V5.58198C7.07597 6.43398 6.39798 7.11797 5.55198 7.11797H3.52399C2.684 7.11797 2 6.43398 2 5.58198V3.53659C2 2.69 2.684 2 3.52399 2H5.55198ZM12.476 2C13.316 2 14 2.69 14 3.53659V5.58198C14 6.43398 13.316 7.11797 12.476 7.11797H10.448C9.60202 7.11797 8.92403 6.43398 8.92403 5.58198V3.53659C8.92403 2.69 9.60202 2 10.448 2H12.476Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.fc53a65c2d1f023c16ee9d873fc92ee9.svg";
export { ForwardRef as ReactComponent };